module.exports = __webpack_public_path__ + "static/img/vehicle_violation_account_guide_1.26fb1fb.png";